export default __webpack_public_path__ + "static/lb3-e0e2d43bedb3fe2152a77535117ce9ec.webp";